import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  mdas: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "mda",
  initialState,
  reducers: {
    getMdaSuccess: (state, { payload }) => {
      state.mdas = payload;
      state.loading = false;
    },
    startLoadingMda: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllMdas = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
     
      dispatch(slice.actions.startLoadingMda());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-mdas`,
        { headers }
      );
      dispatch(slice.actions.getMdaSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};


